module.exports = __webpack_public_path__ + "static/media/exit-btn.72865eb4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/exit-btn.svg
// module id = 868
// module chunks = 21